import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ImportService {

    private importUrl = environment.coreUrl;

    constructor(private http: HttpClient) {}

    addImportFile(data) {
        return this.http.post(this.importUrl + "ImportFile", data).toPromise().then(res => res);
    }

    addContactImportFile(data) {
        return this.http.post(this.importUrl + "ImportFile/ImportContactFile", data).toPromise().then(res => res);
    }

    importFile(data: any): Observable<any> {
        return this.http.post(this.importUrl + "ImportFile", data);
    }

    addWorkbookToAccount(data: any): Observable<any> {
        return this.http.post(this.importUrl + "ImportFile/AddWorkbookToAccountImport", data);
    }
}
